<script lang="ts">
    import WhiteColor from '../../../shared/WhiteColor.svelte';
    import IconCheck from '../../../shared/Icons/IconCheck.svelte';

    export let value = '';
    export let isApproached = false;
    export let isCompleted = false;
</script>

{#if isCompleted}
    <WhiteColor>
        <IconCheck scale={0.5} />
    </WhiteColor>
{:else}
    {value}
{/if}
